import { render, staticRenderFns } from "./flex-item.vue?vue&type=template&id=9d719b5c&scoped=true"
import script from "./flex-item.vue?vue&type=script&lang=js"
export * from "./flex-item.vue?vue&type=script&lang=js"
import style0 from "./flex-item.vue?vue&type=style&index=0&id=9d719b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d719b5c",
  null
  
)

export default component.exports